import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartData,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

interface DoughnutChartProps {
  title: string;
  labels: string[];
  values: number[];
}
const DoughnutChart = ({ title, labels, values }: DoughnutChartProps) => {
  const options = {
    // cutout: 70, // Percentage of the Doughnut filled (weight)
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        cornerRadius: 2,
      },
    },
  };
  // connected, connectedWithErrors, disconnected, neverConnected
  const data: ChartData<'doughnut', number[], string> = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: [
          '#45B649C8', // Green
          '#FDC830C8', // Yellow
          '#ED213AC8', // Red
          '#f4faffC8', // Blue
        ],
        borderColor: '#bdc3c7',
        borderWidth: 1.5,
      },
    ],
  };

  return (
    <div style={{ width: '20rem' }}>
      <div style={{ position: 'relative' }}>
        <Doughnut options={options} data={data} />
        <p
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '2.5rem',
          }}
        >
          {
            values
              .reduce((previousValue: number, currentValue: number) => (
                previousValue + currentValue
              ))
          }
        </p>
      </div>
      <h4 style={{ marginTop: '1rem', textAlign: 'center' }}>{ title }</h4>
    </div>
  );
};

export default DoughnutChart;
